// First, so its listeners are in place before anything else can throw.
import { reportError } from './scripts/error-reporting.js';
import collapse from '@alpinejs/collapse';
import intersect from '@alpinejs/intersect';
import focus from '@alpinejs/focus';
import ui from '@alpinejs/ui';
import layout from './scripts/layout.js';
import portfolio from './scripts/portfolio.js';
import services from './scripts/services.js';
import bezierWaves from './scripts/bezier-waves.js';
import gravityWell from './scripts/gravity-well.js';
import starfield from './scripts/starfield.js';
import plasmaField from './scripts/plasma-field.js';
import { registerNavStore } from './scripts/nav-store.js';
import { hasMarketingConsent, registerConsentStore } from './scripts/consent-store.js';
import { registerLeadForms } from '@enovatedesign/astro-lead-forms/alpine';
import gallery from './scripts/gallery.js';
import lightbox from './scripts/lightbox.js';
// Side-effect import: forces a hard load when a client-side navigation lands on
// HTML from a newer deployment than the bundle running it.
import './scripts/build-guard.js';

export default (Alpine) => {
    Alpine.plugin(collapse);
    Alpine.plugin(intersect);
    Alpine.plugin(focus);
    Alpine.plugin(ui);
    Alpine.store('timeline', { showAll: false });
    registerNavStore(Alpine);
    registerConsentStore(Alpine);
    // Enquiry and booking flyouts, also capturing ad click IDs on load; nothing
    // is written to the device until marketing consent is granted.
    registerLeadForms(Alpine, { hasMarketingConsent, reportError });
    Alpine.data('layout', layout);
    Alpine.data('portfolio', portfolio);
    Alpine.data('services', services);
    Alpine.data('bezierWaves', bezierWaves);
    Alpine.data('gravityWell', gravityWell);
    Alpine.data('starfield', starfield);
    Alpine.data('plasmaField', plasmaField);
    Alpine.data('gallery', gallery);
    Alpine.data('lightbox', lightbox);
}
